import {Injectable} from '@angular/core';
import {ApiService} from '@core/services/api.service';
import {IResponseApi} from '@core/models';
import {
  IBannerCreateParams,
  IBannerItemData,
  IBannerListData,
  IBannerListParams,
  IBannerRemoveData,
  IBannerRemoveParams,
  IBannerUpdateParams
} from '@shared/models/business';

@Injectable({
  providedIn: 'root',
})
export class BannerService extends ApiService {
  private readonly endpoint = '/business/banner';

  list(params: IBannerListParams = {}) {
    return this.postRequest<IResponseApi<IBannerListData>>(`${this.endpoint}/list`, params);
  }

  listPublic(params: IBannerListParams = {}) {
    return this.postGuestRequest<IResponseApi<IBannerListData>>(`${this.endpoint}/list`, params);
  }

  add(params: IBannerCreateParams) {
    return this.postRequest<IResponseApi<IBannerItemData>>(`${this.endpoint}/add`, params);
  }

  update(params: IBannerUpdateParams) {
    return this.postRequest<IResponseApi<IBannerItemData>>(`${this.endpoint}/update`, params);
  }

  remove(params: IBannerRemoveParams) {
    return this.postRequest<IResponseApi<IBannerRemoveData>>(`${this.endpoint}/remove`, params);
  }
}
